import { DataSource, mapDataSource } from '~/Api/DataSource';
import mapGroupedDataSource from '~/Api/DataSource/mapGroupedDataSource';

import type ApiClient from '~/ApiClient';

export interface Result {
	items: DataSource;
}

export default async function findDataSources(client: ApiClient): Promise<Result> {
	const request = await client.fetch('products/searchable-datasources');
	const response = await request.json();
	const sortedItems = response.items.sort((a: DataSource, b: DataSource) => {
		const nameA = a.country?.name?.toLowerCase() || '';
		const nameB = b.country?.name?.toLowerCase() || '';
		return nameA.localeCompare(nameB);
	});
	return {
		items: sortedItems.map(mapDataSource),
	};
}

export async function findGroupedDataSources(client: ApiClient): Promise<Result> {
	const request = await client.fetch('customer-datasource-groups');
	const response = await request.json();
	return { items: response.items.map(mapGroupedDataSource) };
}
